export function getTextInitials(text: string) {
  return text
    .split(' ')
    .map((word) => word.slice(0, 1).toUpperCase())
    .join('');
}
